(function () {
    'use strict';

    angular
        .module('elogbooks.user.service-providers')
        .controller('UserServiceProvidersDetailsInfoController', UserServiceProvidersDetailsInfoController);

    UserServiceProvidersDetailsInfoController.$inject = ['serviceProviderResponse', 'userManager', 'elbSettings', 'modulesService'];

    function UserServiceProvidersDetailsInfoController(serviceProviderResponse, userManager, elbSettings, modulesService) {
        var vm = this;
        vm.serviceProvider = serviceProviderResponse;
        vm.hasManageSPPermission = userManager.hasPermission('user_permission_manage_service_providers');
        vm.spFeedbackEnabled = elbSettings.getSetting('sp_feedback_enabled').value;
        vm.prosureEnabled =  !!elbSettings.getSetting('prosure_enabled').value;
        vm.assetsModuleEnabled = modulesService.isEnabled('assets_module');
    }
})();
